import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiCircularGradientProgressBarComponent } from './fi-circular-gradient-progress-bar.component';

@NgModule({
    imports: [CommonModule],
    declarations: [FiCircularGradientProgressBarComponent],
    exports: [FiCircularGradientProgressBarComponent],
})
export class FiCircularGradientProgressBarModule {}
